export const isUnknownPayment = (row) => ['UNKNOWN'].includes(String(row?.resultState || '').toUpperCase()) || String(row?.transaction_status ?? row?.transactionStatus ?? row?.status ?? '').toUpperCase() === 'UNKNOWN';

export const paymentResultFields = (row) => ({
  resultState: row.resultState,
  resultConfirmationSource: row.resultConfirmationSource,
  resultConfirmedAt: row.resultConfirmedAt,
  adminReviewRequired: row.adminReviewRequired,
  retryRecommended: row.retryRecommended,
  resultMessage: row.resultMessage ?? row.out_rslt_msg ?? row.outRsltMsg ?? '',
});

export const unknownPaymentLabel = (row) => String(row?.transaction_type ?? row?.transactionType ?? '').toUpperCase() === 'CANCEL' ? '취소 결과 확인 필요' : '결과 확인 필요';
export const unknownPaymentMessage = (cancel = false) => cancel
  ? '취소 결과를 확인 중입니다. 확인 후 취소 완료로 변경될 수 있습니다. 관리자에게 문의해 주세요.'
  : '결제 결과를 확인 중입니다. 실제 승인되었을 수 있으며, 확인 후 승인 완료로 변경될 수 있습니다. 중복 결제 방지를 위해 재결제를 권장하지 않습니다. 관리자에게 문의해 주세요.';

export function showUnknownPayment(response, domain, cancel = false) {
  const data = response?.data ?? response;
  if (!isUnknownPayment(data)) return false;
  window.dispatchEvent(new CustomEvent('payment-result-unknown', { detail: {
    domain, cancel, paymentTransactionId: Object.prototype.hasOwnProperty.call(data, 'paymentTransactionId') ? data.paymentTransactionId : data.provider_result?.paymentTransactionId ?? null,
  } }));
  return true;
}

export function safePaymentResultMessage(row) {
  const message = String(row?.resultMessage || '');
  return message && !/bad decrypt|decrypt|openssl|stack|exception|error:/i.test(message) ? message : unknownPaymentMessage(String(row?.transaction_type ?? row?.transactionType ?? '').toUpperCase() === 'CANCEL');
}
